import { useQuery, registerQuery } from 'data-fetching-client';
import { getIsThemePreview, getPortalName } from '../utils/metadata';
import { matchByDomain } from '../utils/domainMatch';
export const FETCH_BRAND_DATA = registerQuery({
  fieldName: 'brandData',
  fetcher: async () => {
    const portalName = getPortalName();
    if (!portalName) {
      throw new Error('Missing portalName');
    }
    const isThemePreviewer = getIsThemePreview();
    const basePath = `/hs/portals/${portalName}/brand`;
    const searchParams = new URLSearchParams(window.location.search);
    const previewToken = searchParams.get('hs_preview');
    const themeSettingsVersion = searchParams.get('theme_settings_version');
    let queryString = '';
    if (isThemePreviewer) {
      const brandParams = new URLSearchParams();
      if (previewToken) {
        brandParams.set('hs_preview', previewToken);
      }
      if (themeSettingsVersion) {
        brandParams.set('theme_settings_version', themeSettingsVersion);
      }
      queryString = brandParams.toString();
    }
    const requestUrl = queryString ? `${basePath}?${queryString}` : basePath;
    let res;
    try {
      res = await fetch(requestUrl);
    } catch (e) {
      throw new Error('Failed to fetch brand data', {
        cause: e
      });
    }
    if (!res.ok) {
      console.error(`Brand data fetch failed: ${res.status} ${res.statusText}`);
      throw new Error('Failed to fetch brand data');
    }
    const data = await res.json();
    return data;
  }
});
export function useBrandData() {
  const {
    data
  } = useQuery(FETCH_BRAND_DATA);
  return data === null || data === void 0 ? void 0 : data.brandData;
}
export function useBrandSettings() {
  var _portalData$context;
  const portalData = useBrandData();
  return portalData === null || portalData === void 0 || (_portalData$context = portalData.context) === null || _portalData$context === void 0 ? void 0 : _portalData$context.brandSettings;
}
export function useFavicon() {
  var _brandSettings$primar;
  const brandSettings = useBrandSettings();
  return (_brandSettings$primar = brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.primaryFavicon) !== null && _brandSettings$primar !== void 0 ? _brandSettings$primar : brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.favicon;
}
export function useLogo() {
  var _brandSettings$logos, _ref;
  const brandSettings = useBrandSettings();
  const domainMatch = matchByDomain((_brandSettings$logos = brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.logos) !== null && _brandSettings$logos !== void 0 ? _brandSettings$logos : [], window.location.hostname);
  return (_ref = domainMatch !== null && domainMatch !== void 0 ? domainMatch : brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.primaryLogo) !== null && _ref !== void 0 ? _ref : brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.logo;
}
export function useBrandName() {
  var _portalData$context2;
  const portalData = useBrandData();
  return portalData === null || portalData === void 0 || (_portalData$context2 = portalData.context) === null || _portalData$context2 === void 0 ? void 0 : _portalData$context2.brandName;
}
export function useCompanyName() {
  var _portalData$context3;
  const portalData = useBrandData();
  return portalData === null || portalData === void 0 || (_portalData$context3 = portalData.context) === null || _portalData$context3 === void 0 ? void 0 : _portalData$context3.companyName;
}